import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../assets/styles/layers.scss";
import LayersIcon from "../assets/images/server_rgb_red.svg";
import CreateLayerForms from "../components/Layers/Create/CreateLayerForms";
import MapInstruction from "../components/Layers/MapInstruction";
import InformationLayerMap from "../components/InformationLayerMap";
const LayerCreateOne = () => {
  const [currentArea, setCurrentArea] = useState(null);
  const [selectedColor, setSelectedColor] = useState("#000000");

  const handleAreaUpdate = (newArea) => {
    setCurrentArea(newArea);
  };

  
  return (
    <div className="layers-container">
      <Container fluid>
        <Row className="align-items-center mb-4">
          <Col>
            <div className="d-flex align-items-center">
              <img
                src={LayersIcon}
                alt="Layers Icon"
                style={{ width: "30px", height: "30px", marginRight: "12px" }}
              />
              <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", margin: 0 }}>
                Dodanie nowej warstwy
              </h3>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <Row>
              <CreateLayerForms
                area={currentArea}
                selectedColor={selectedColor}
                onColorChange={setSelectedColor}
              />
            </Row>
            <Row>
              <MapInstruction
                containerProps={{ fluid: true, className: "my-3" }}
                variant="light"
                bordered
              />
            </Row>
          </Col>
          <Col xs={12} md={8}>
            <InformationLayerMap
              area={currentArea}
              color={selectedColor}
              onAreaUpdate={handleAreaUpdate}
              editable={true}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LayerCreateOne;
